let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4dniO")).then(() => parcelRequire('idjoc'));